import React from "react";
import { connect } from "react-redux";
import {
  actions,
  currentEpisodeActions,
  poppinFormActions,
  readingActions,
  signinActions
} from "../../../actions";
import * as socialControlsActions from "../../../actions/socialControlsActions";
import { abbreviatedNumber } from "../../design/utilities";
import Icon from "../../design/socialControls/Icon";
import { IconWithCounter } from "../../design/socialControls/Icon";
import { isLogged, isNotLogged, socialIcons } from "../helpers";

class Icons extends React.Component {
  handlePoppinsToggle = event => {
    event.preventDefault();
    this.props.poppinsToggle();
  };

  handleLikeEpisode = event => {
    event.preventDefault();

    if (isLogged()) {
      this.props.toggleLike(this.props.currentEpisode.id);
    } else {
      this.props.openSigninModalWithCallback(this.props.toggleLike, "toggleLike", [
        this.props.currentEpisode.id
      ]);
    }
  };

  toggleSocialsList = () => {
    this.props.socialControls.socialsOpened
      ? this.props.closeSocialDropdown()
      : this.props.openSocialDropdown();
  };

  toggleSlidingDrawer = (type, data) => {
    if (
      this.props.socialControls.slidingDrawer.opened &&
      type === this.props.socialControls.slidingDrawer.currentContent
    ) {
      this.props.closeDrawer();
    } else {
      if (isNotLogged() && type === "reportMenu") {
        this.props.openSigninModalWithCallback(
          this.props.fetchDrawerContent,
          "fetchDrawerContent",
          [type, data]
        );
      } else {
        this.props.fetchDrawerContent(type, data);
        this.props.openDrawer(type);
      }
    }
  };

  render = () => {
    const {
      poppinIcon,
      likeIcon,
      likesCount,
      currentEpisode,
      paginationInfo,
      commentsCount,
      publicationType
    } = this.props;
    return (
      <div className="right">
        {publicationType !== "novel" && (
          <Icon img={poppinIcon} onClick={this.handlePoppinsToggle} />
        )}
        <IconWithCounter img={likeIcon} onClick={this.handleLikeEpisode} count={likesCount} />
        <IconWithCounter
          img={socialIcons.comment}
          onClick={this.toggleSlidingDrawer.bind(this, "commentList", {
            episode_id: currentEpisode.id,
            page_number: paginationInfo.next_page
          })}
          count={commentsCount}
        />
        <Icon img={socialIcons.share} onClick={this.toggleSocialsList} />
        <Icon
          className="t-pl2-m t-pl1"
          img={socialIcons.report}
          onClick={this.toggleSlidingDrawer.bind(this, "reportMenu")}
        />
      </div>
    );
  };
}

const mapState = (state, ownProps) => ({
  socialControls: state.socialControls,
  commentsCount:
    state.currentEpisode.episode &&
    abbreviatedNumber(state.currentEpisode.episode.public_stats.pop_comments_count, 1),
  currentEpisode: state.currentEpisode,
  likesCount:
    state.currentEpisode.episode &&
    abbreviatedNumber(state.currentEpisode.episode.public_stats.likes_count, 1),
  paginationInfo: state.socialControls.slidingDrawer.commentsList.paginationInfo,
  poppinIcon: state.reading.showPoppins ? socialIcons.poppinOn : socialIcons.poppinOff,
  likeIcon: state.currentEpisode.liked ? socialIcons.liked : socialIcons.like,
  publicationType: state.story.publication_type
});

const mapDispatch = dispatch => ({
  fetchDrawerContent: (type, data) => {
    dispatch(socialControlsActions.fetchDrawerContent(type, data));
  },
  openDrawer: type => {
    dispatch(actions.episodesControlsSetClosed());
    dispatch(signinActions.closeLanguageMenu());
    dispatch(signinActions.closeUserMenu());
    dispatch(socialControlsActions.openDrawer(type));
  },
  closeDrawer: () => {
    dispatch(socialControlsActions.closeDrawer());
  },
  openSocialDropdown: () => {
    dispatch(actions.episodesControlsSetClosed());
    dispatch(signinActions.closeLanguageMenu());
    dispatch(signinActions.closeUserMenu());
    dispatch(socialControlsActions.openSocialDropdown());
  },
  closeSocialDropdown: () => {
    dispatch(socialControlsActions.closeSocialDropdown());
  },
  toggleLike: episodeId => {
    dispatch(currentEpisodeActions.episodeToggleLike(episodeId));
  },
  poppinsToggle: () => {
    dispatch(readingActions.poppinsToggle());
    dispatch(poppinFormActions.poppinFormClose());
    dispatch(readingActions.openedPoppinToggle());
  },
  openSigninModalWithCallback: (callback, callbackType, callbackArgs) => {
    dispatch(signinActions.openModalWithCallback(callback, callbackType, callbackArgs));
  }
});

export default connect(mapState, mapDispatch)(Icons);
